import { useAppStore } from '../store/app-store.js';

export function prefersReducedMotionOs(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Resolved reduced-motion preference combining the user's store setting and the
 * OS-level media query. Returns `true` whenever motion should be reduced.
 */
export function prefersReducedMotion(): boolean {
  try {
    const pref = useAppStore.getState().reducedMotion;
    if (pref === 'always') return true;
    if (pref === 'never') return false;
  } catch {
    // store unavailable; fall through to OS
  }
  return prefersReducedMotionOs();
}

/** Return `fallback` when reduced motion is on; otherwise `value`. */
export function respectReducedMotion<T>(value: T, fallback: T): T {
  return prefersReducedMotion() ? fallback : value;
}
